<script>
import axios from 'axios';
import { formatCurrencyNoRM } from "@/helpers/function";
export default {

    props: {
        cust_id :{
            type : Number,
        },
    },

    data() {
        return {
            Collection:[],
        }
    },

    methods:{
        GetCollectionData(cust_id){
      
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'dashboard/customer/collection/'+cust_id)
            .then(response => {
                if (response) {
                    this.Collection=response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        formatCurrencyNoRM,
    },
    mounted() {
        this.GetCollectionData(this.cust_id);
    }
}
</script>
<template>
    <div class="tab-pane active" id="collectiondetails" role="tabpanel">
        <h5>Collection Details</h5>
        <table class="table">
            <thead>
            <tr>
                <th scope="col">Actual Monthly Charges (RM)</th>
                <td scope="col">{{  Collection.month_payable_amount }}</td>
            </tr>
            <tr v-if="Collection.knock_off_amount < 0" >
                <th scope="row">(-) Security Deposit Offset (RM)</th>
                <td>{{  formatCurrencyNoRM(Collection.knock_off_amount) }}</td>
            </tr>
            <tr v-if="Collection.knock_off_amount < 0" style="color: green;">
                <th scope="row">Net Monthly Payment (RM)</th>
                <td>{{ formatCurrencyNoRM(Collection.newly_monthly_amount) }}</td>
            </tr>
            <tr v-if="Collection.knock_off_amount < 0" >
                <th scope="row">Total Security Deposit (RM)</th>
                <td>{{  formatCurrencyNoRM(Collection.security_deposit_amount) }}</td>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th scope="row">Total Late Payment Charge (RM)</th>
                <td>{{  formatCurrencyNoRM(Collection.total_late_pay) }}</td>

            </tr>
            <tr>
                <th scope="row">Collection Date</th>
                <td>{{  Collection.collection_date }}</td>

            </tr>
            <tr>
                <th scope="row">No. of Successful Collection</th>
                <td>{{  Collection.success_collection }}</td>
            </tr>
            <tr>
                <th scope="row">No. of Failed Collection</th>
                <td>{{  Collection.fail_collection }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>